import React from 'react';
import { Link } from 'react-router-dom';
import Room from 'material-ui/svg-icons/action/group-work';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import { FormattedMessage } from 'react-intl';
import { guestMenuItemStyles } from './styles';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import Sidebar from 'react-sidebar';
import { checkView } from '../../lib';

(function () {
  var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = window.location.origin + '/img/faviconFVlite.ico';
  document.getElementsByTagName('head')[0].appendChild(link);
})();

class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebar: true,
    };
  }

  componentDidMount() {
    checkView();
    let body = document.getElementsByTagName('body');
    if(body) {
      body[0].style = "overflow: hidden";
    }
  }

  getSideMenuItem = () => {
    return (
      <Menu
        disableAutoFocus
        selectedMenuItemStyle={{
          backgroundColor: 'rgba(231, 235, 240, 0.2)',
          color: '#000000de',
        }}
        value={this.props.path}
        autoWidth={false}
        width="100%"
        listStyle={{ width: '0.01%' }}
        className="fv-menu"
        style={{ width: '100%', display: 'block' }}
      >
        <MenuItem
          onClick={() => {
            setTimeout(() => {
              window.location.reload();
            }, 100);
          }}
          value={'/fvdomain/create'}
          primaryText={<FormattedMessage id="DomainFVliteNavigation.create" />}
          containerElement={<Link to={'/fvdomain/create'} />}
          leftIcon={<Room color={'#000000de'} />}
          className="fv-menu-item"
        />
        <MenuItem
          value={'/edit_news?type=FVlite'}
          primaryText={<FormattedMessage id="DomainFVliteNavigation.news" />}
          containerElement={<Link to={'/edit_news?type=FVlite'} />}
          leftIcon={<Room color={'#000000de'} />}
          className="fv-menu-item"
        />
        <MenuItem
          value={'/fvdomain/problem-reports'}
          primaryText={<FormattedMessage id="DomainFVliteNavigation.problemReport" />}
          containerElement={<Link to={'/fvdomain/problem-reports'} />}
          leftIcon={<Room color={'#000000de'} />}
          className="fv-menu-item"
        />
      </Menu>
    );
  };

  getRootSidebarClass = () => {
    if ((this.props.view === 'mobile' || this.props.view === 'sm-mobile') && this.props.openSidebar) {
      return 'mobile-open fv-domain-sidebar  fv-domain';
    } else if ((this.props.view === 'mobile' || this.props.view === 'sm-mobile') && !this.props.openSidebar) {
      return 'mobile-close fv-domain-sidebar  fv-domain';
    } else if (this.props.view === 'desktop') {
      return 'desktop-view fv-domain-sidebar fv-domain';
    }
  };

  render() {
    return (
      <div className="h-100 flex flex-column justify-between">
        <Helmet>
          <title>{'Lite FreshVoice'}</title>
        </Helmet>
        <Sidebar
          children=""
          sidebar={this.getSideMenuItem()}
          open={this.props.openSidebar}
          // onSetOpen={this.onSetSidebarOpen}
          styles={{ sidebar: { background: '#f6f9fc', top: '65px' } }}
          shadow={false}
          transitions={true}
          rootClassName={this.getRootSidebarClass()}
          sidebarClassName="fv-sidebar"
          overlayClassName="sidebar-overlay"
          onSetOpen={() => {
            this.props.toggleSideBar(false);
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  role: state.loginLayout.user.fvlite_role,
});

export default connect(mapStateToProps)(Navigation);



// WEBPACK FOOTER //
// src/layouts/Domain/Navigation.js